const descriptorManagement = {
  bindings: {
    moduleList: '<',
  },
  templateUrl: '/modules/packageManagement/descriptor-management/descriptor-management.html',
  controller: 'descriptorManagementController',
};

angular
  .module('package-management.module')
  .component('descriptorManagement', descriptorManagement)
  .config(function($stateProvider) {
    $stateProvider.state('files.descriptormanagement', {
      url: '/descriptor-management',
      views: {
        'management@files': 'descriptorManagement',
      },
      resolve: {
        moduleList: PackageService => PackageService.getModules(),
      },
    });
  });
